import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';

interface TimePreset {
  labelKey: string;
  fallback: string;
  startTime: string;
  endTime: string;
}

const TIME_PRESETS: TimePreset[] = [
  {
    labelKey: 'availability.wizard.presets.nineToFive',
    fallback: '9 to 5',
    startTime: '09:00',
    endTime: '17:00',
  },
  {
    labelKey: 'availability.wizard.presets.morning',
    fallback: 'Morning',
    startTime: '08:00',
    endTime: '12:00',
  },
  {
    labelKey: 'availability.wizard.presets.afternoon',
    fallback: 'Afternoon',
    startTime: '13:00',
    endTime: '18:00',
  },
  {
    labelKey: 'availability.wizard.presets.evening',
    fallback: 'Evening',
    startTime: '18:00',
    endTime: '22:00',
  },
];

interface TimePresetsProps {
  startTime: string;
  endTime: string;
  onTimeChange: (start: string, end: string) => void;
  className?: string;
}

export function TimePresets({
  startTime,
  endTime,
  onTimeChange,
  className,
}: TimePresetsProps) {
  const { t } = useTranslation('staff');

  return (
    <div className={cn('flex flex-wrap gap-2', className)}>
      {TIME_PRESETS.map((preset) => {
        const isActive =
          startTime === preset.startTime && endTime === preset.endTime;

        return (
          <button
            key={preset.labelKey}
            type="button"
            onClick={() => onTimeChange(preset.startTime, preset.endTime)}
            className={cn(
              'px-4 py-2 text-sm font-medium rounded-lg border transition-colors tap-highlight-transparent',
              'active:scale-[0.98]',
              isActive
                ? 'bg-blue-100 border-blue-300 text-blue-700'
                : 'bg-white border-gray-200 text-gray-600 hover:border-gray-300 active:bg-gray-50'
            )}
          >
            {t(preset.labelKey, preset.fallback)}
          </button>
        );
      })}
    </div>
  );
}
